/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { BookRequestBuilderRequestsMetadata, type BookRequestBuilder } from './book/index.js';
// @ts-ignore
import { PricesRequestBuilderRequestsMetadata, type PricesRequestBuilder } from './prices/index.js';
// @ts-ignore
import { type VerifyRequestBuilder, VerifyRequestBuilderNavigationMetadata } from './verify/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /Booking
 */
export interface BookingRequestBuilder extends BaseRequestBuilder<BookingRequestBuilder> {
    /**
     * The Book property
     */
    get book(): BookRequestBuilder;
    /**
     * The Prices property
     */
    get prices(): PricesRequestBuilder;
    /**
     * The Verify property
     */
    get verify(): VerifyRequestBuilder;
}
/**
 * Uri template for the request builder.
 */
export const BookingRequestBuilderUriTemplate = "{+baseurl}/Booking";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const BookingRequestBuilderNavigationMetadata: Record<Exclude<keyof BookingRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    book: {
        requestsMetadata: BookRequestBuilderRequestsMetadata,
    },
    prices: {
        requestsMetadata: PricesRequestBuilderRequestsMetadata,
    },
    verify: {
        navigationMetadata: VerifyRequestBuilderNavigationMetadata,
    },
};
/* tslint:enable */
/* eslint-enable */
